"use strict";import{baseStyles as e,CiscoUElement as s,html as t}from"@cisco-u/base";import"@cisco-u/base-card/cu-base-card.js";import"@cisco-u/links-external/cu-links-external.js";import l from"./grid-box.css.js";export class GridBox extends s{static get styles(){return[e,l]}render(){return t`<div class="base-card">
      <div class="flex">
        <h3 class="heading">
          <slot name="heading">Grid Block</slot>
        </h3>
        <div class="link">
          <slot name="link"></slot>
        </div>
        <div class="image"><slot name="image"></slot></div>
      </div>
    </div>`}}
//# sourceMappingURL=GridBox.js.map
